import { ActivatedRoute, ParamMap, Router} from '@angular/router'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewRef, Output, EventEmitter, Input, LOCALE_ID } from '@angular/core'
import { formatDate } from '@angular/common'
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms'
import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { Observable, BehaviorSubject, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged,startWith,map } from 'rxjs/operators'

import * as moment from 'moment'
//ANGULAR MATERIAL
import { ErrorStateMatcher } from '@angular/material/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
//SERVICES
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, TiersService ,StateService, ParameterService, VisiteService, ConnectionService} from '../../../../../services'
//COMPONENTS
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { PeriodicalCreationComponent } from '../../../layout/dialogs/periodical-creation-dialog/periodical-creation.component'
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'


const KEY = 'create-consultation-dialog'

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(
		control: FormControl | null,
		form: FormGroupDirective | NgForm | null
	): boolean {
		const isSubmitted = form && form.submitted
		return !!(
			control &&
			control.invalid &&
			(control.dirty || control.touched || isSubmitted)
		)
	}
}

@Component({
	selector: 'atyl-create-consultation-dialog',
	templateUrl: './create-consultation-dialog.component.html',
	styleUrls: ['./create-consultation-dialog.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/actions/create-consultation-dialog',
	key: KEY, 
})
export class CreateConsultationDialogComponent extends BaseDialogComponent implements OnInit {
	@StringableValues(KEY) strings: any
	typeFormControl = new FormControl('', [Validators.required]);
	locationFormControl = new FormControl('', [Validators.required]);
	myFormControl = new FormControl('', []);
	myFormControlTitle = new FormControl('', []);
	  
	matcher = new MyErrorStateMatcher();
	invalidDate = false;

	loading: boolean = false;

	removable: boolean = true;
	separatorKeysCodes: number[] = [ENTER, COMMA];
	tiersControl = new FormControl('', [Validators.required]);
	tiersSearchList = [];
	tiersSearchIsEmpty = true;
	tiersId = [];
	tiersSelected = [];
	suiviSearchTerm: string

	consultationGroup = [];
	consultationLocation = [];
	consultationProfessionnel = [];
	HOUR = new Array(25);

	groupeInput: any
	typeInput: any
	dateInput: any
	startTimeInput: any
	endTimeInput: any
	atHomeInput: boolean
	consultationStateInput: any
	hourIntervalInput: any
	
	minuteIntervalDefautlt: number=20;
	minuteIntervalInput: number=20;
	locationInput: any
	titre:any;
	comment:any;
	periode:any;
	dateF:any;
	nbConsult: any;
	maDate: any;
	consultation:any;
	interval: any
	selectedDays: any
	monthNumber: any
	weekNumber: any
		
	monthMethod: any
	//toLoadConsultion:boolean=false;
	toLoadConsultion:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(true);
	toLoadConsultionSlider:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	
	valueDebut: any = '08:00';
    valueFin: any = '17:00';
	
	etats = [];
	statusInput: any;
	
	errors:any =[]
	errorMessage:string ="";
	
	drawerRightIsOpen: boolean = false;
	
	myConsultation: boolean =true;
	consultationList: any[] = [];
	hiddenElements: boolean = true;
	fromQueryParams: ParamMap;
	day = new Date();
	
	town:any[] = [];
    townOptions: Observable<any[]>;
    
	updateOnCreate: boolean = true;

	
	toLoadDate:BehaviorSubject<Date>=new BehaviorSubject<Date>(new Date());
	toLoaProfesionnel:BehaviorSubject<number[]>=new BehaviorSubject<number[]>([]);

    plage:number=0;
	
	
	@ViewChild('professionalInput', { read: undefined, static: undefined })
	professionalInput: ElementRef<HTMLInputElement>
	professions:any[]=[];
	
	tiersSearchGroupList:any[]=[];
    test:any[]=[];
    user: any;
	tiersSearchGroupOptions: Observable<any[]>;
    proFormControl = new FormControl('', [Validators.required]);
	consultModif: Subject<any> = new Subject<any>();

	consultChangeDebounce = new Subject<any>();

	instruction:any;
	restriction_type:any[]=[];
	
	disabledForm:boolean=false;
	meessageForm:string="";
	isModify:boolean=false;
	
	dialogContainer:any;

	initLieuSubject:BehaviorSubject<any> = new BehaviorSubject<any>([]);
	
	rdvApplicate: boolean = false;
	
	rdvApplicateLabel:string="Appliquer aux rendez-vous";
	oldPlace:any;
	rdvs:any[]=[];
    rdvsActioned:any[]=[];
	
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private consultationService: ConsultationService,
		private visiteService: VisiteService,
		private tiersService: TiersService,
        private connectService: ConnectionService,
		changeDetectorRef: ChangeDetectorRef,
		public dialogRef: MatDialogRef<CreateConsultationDialogComponent>,
		dialogService: DialogService,
		private stateService: StateService,
		private activatedRoute: ActivatedRoute,
		public dialog: MatDialog,
        private parameterService: ParameterService,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
       // this.dialogRef.updateSize("900px","700px")
        console.log("dataConsult:",this.data);
		
		if (this.data!=undefined
			&& this.data.old_consultation!=undefined) {
				console.log("old consultation",this.data.old_consultation);
				if (this.data.old_consultation!=undefined) {
					if (this.data.types!=undefined 
					         
					           ){
			               for(let i=0;i<this.data.types.length;i++)
			                   if (this.data.types[i].ID==this.data.old_consultation.type.ID) {
			                           this.typeInput=this.data.types[i];
			                       
			                   }
						}   
					if (this.data.old_consultation.lieu!=undefined && this.data.old_consultation.lieu) {
						/*this.locationInput=this.data.old_consultation.lieu.ID;
						this.initLieuSubject.next(this.locationInput);*/
						this.consultation={
							lieu:this.data.old_consultation.lieu,
							visites: 0
						};
					
						if (this.data.old_consultation.visites!=undefined && this.data.old_consultation.visites
							&& this.data.old_consultation.visites>0
						 )
						 this.consultation.visites= this.data.old_consultation.visites;
						
						 if (this.data.old_consultation.visitesObj!=undefined 
							&& Array.isArray(this.data.old_consultation.visitesObj)
						 						/*	&& this.data.old_consultation.visitesObj.length>0*/
						 						 ) {
								console.log("old consultation visitesObj",Array.isArray(this.data.old_consultation.visitesObj),this.data.old_consultation.visitesObj.length)									
						 		this.consultation.visites= this.data.old_consultation.visitesObj.length;
							}					 
						console.log("old consultation new",this.consultation)						 
												 
					}
					
					if (this.data.old_consultation.titre!=undefined && this.data.old_consultation.titre) 
						this.titre=this.data.old_consultation.titre;
						
					
					
					if (this.data.old_consultation.commentaire!=undefined && this.data.old_consultation.commentaire) 
						this.comment=this.data.old_consultation.commentaire;
											
					if (this.data.old_consultation.intervalle!=undefined && this.data.old_consultation.intervalle) 
						this.minuteIntervalInput=this.data.old_consultation.intervalle;					
					if (this.data.old_consultation.date_debut!=undefined && this.data.old_consultation.date_fin) {
						let begin= new Date(this.data.old_consultation.date_debut);
		                let end= new Date(this.data.old_consultation.date_fin);    
		                this.dateInput=begin;
						               
		                this.valueDebut=formatDate(begin, 'HH:mm', 'fr')
		                this.startTimeInput=this.valueDebut;
		                this.valueFin=formatDate(end, 'HH:mm', 'fr')
					}	
					this.changeTypeGroup(this.typeInput);
					
					
					if (this.data.old_consultation.professionels!=undefined && this.data.old_consultation.professionels
						&& this.data.old_consultation.professionels.length>0
					) 
						this.data.old_consultation.professionels.forEach(el => {
						                    this.tiersId.push(el.ID);
						                    this.tiersService
						                    .getTiersByConsultationType(this.typeInput.ID, {
						                        /*tiersId: el.ID,
						                        term: term,*/
						                    })
						                    .subscribe((res: JSONRpcResponse) => {
						                        this.tiersSearchList = res.result
						                        
						                        this.tiersSearchList.forEach(t =>{
						                            if(t.tiers.ID == el.ID){
						                                this.tiersSelected.push(t.tiers);
						                            }
						                        })
						                        this._groupSearchList();
						                        this.changeDetectorRef.detectChanges()
						                    })
						  });
					
				}
				
		}
		
		this.connectService.user().subscribe((res: JSONRpcResponse) =>{
            if(res)
                this.user = res.result;
        })
		
		if (this.data!=undefined && this.data.instruction!=undefined) {
					            this.instruction = this.data.instruction
								
			if (this.instruction.type!=undefined&& this.instruction.type.consultations!=undefined)
				this.restriction_type= this.instruction.type.consultations
			
            console.log('inconsultation', this.instruction)
		}
		
        if(this.data.dateF && this.data.startTimeInput){
            this.valueDebut = this.data.startTimeInput;
            this.maDate = this.data.dateF;
           
            let date = new Date(Date.parse(this.maDate));
            this.dateInput = date;
        }
        if(this.data.updateOnCreate!=undefined)
           this.updateOnCreate=this.data.updateOnCreate;
        
        this.maDate = "Choisissez une date";
        this.activatedRoute.queryParamMap.subscribe(params => {
			this.fromQueryParams = params
		})
        
        this.startTimeInput=this.valueDebut;
        this.endTimeInput=this.valueFin;
                
        this.consultationService.etats().subscribe((res: JSONRpcResponse) => {
			if (res.result) {
				this.etats=res.result;
				console.log("etats loaded ",this.etats)
				for(let i=0;i<this.etats.length;i++) {
					if (this.etats[i].key=="CREE") {
						this.statusInput=this.etats[i];
					}
				}
				if (this.consultation!=undefined && this.consultation) {
					for(let i=0;i<this.etats.length;i++) {
						if (this.consultation && this.etats[i].key==this.consultation.etat.key) {
							this.statusInput=this.etats[i];
						}    
					}
				}	
				console.log("etats loaded status",this.etats,this.statusInput,this.consultation) 
				this.changeDetectorRef.detectChanges()
			}
		})
        
        if(this.data.page!=undefined && 
        (this.data.page.key == "DOSSIERCONSULATION" || (this.data.page == "bilan seance"))
        ){
            this.stateService.consultation.subscribe((cons: any) => {
                console.log("test cons:",cons);
                if (cons) {
                    this.consultation = cons;
                    this.typeInput = cons.type;
                    if(cons.groupe != null){
                        this.groupeInput = cons.groupe;
                    }
                    console.log("consultation open",this.consultation);
                    this.initData();
                }else{
                    this.consultation = this.data.consultation; 
                    console.log("consultation open",this.consultation);
                    this.initData();
                }

                this.changeDetectorRef.detectChanges();
            })
        }
		if(this.data.page == undefined && this.data.consultation != undefined){
			console.log("___test",this.data.consultation)
			this.consultation = this.data.consultation;
			this.initData();
			this.changeDetectorRef.detectChanges();
		}
        this.getPlageCount()
       
		this.consultChangeDebounce.pipe(
			debounceTime(1500) 
		).subscribe((event) => {
			this.updateSliderObjEdit(event);
		});
		
		
		if (this.strings!=undefined && this.strings.rdvApp!=undefined) {
			this.rdvApplicateLabel=this.strings.rdvApp; 
			if (this.consultation!=undefined && this.consultation.visites!=undefined 
				 && this.consultation.visites && this.consultation.visites>0  ) {
				this.rdvApplicateLabel=this.rdvApplicateLabel.replace("XXX",this.consultation.visites);
				this.rdvApplicate=true;
			} else
				this.rdvApplicateLabel=this.rdvApplicateLabel.replace("XXX","");
			
		}
	}

	ngAfterViewChecked() {
			
			
		
			// this.dialogContainer = document.querySelector('.cdk-global-overlay-wrapper > .cdk-overlay-pane')
			 this.dialogContainer = document.querySelector('.consult_drawer_container')
			if (this.dialogContainer) {
				//console.log("ngAfterViewChecked container",this.dialogContainer)
				this.dialogContainer.addEventListener('resize', this.onResized(this));
			}	
	}	
	
	onResized(event: any): void {
		
		//console.log("onResized before",event,this.formHeight);
		//let sizeH:number=(this.isNomade) ? 205 :165;
		
		if (this.dialogContainer) {
			let header:number=205+ 76
			
			let sizeH:number=this.dialogContainer.clientHeight
			let dateC:any= document.querySelector('.week-container-oneday')
			//console.log("ngAfterViewChecked onResized",sizeH,dateC)
			
			if (dateC!=undefined && (sizeH-header)>0)
				dateC.style="height: "+ (sizeH-header) + "px;";
			
			
			this.dialogContainer.removeEventListener('resize',null);
			
			//console.log("onResized after",event,sizeH,this.formHeight,this.dialogContainer);
		}

		//this.changeDetectorRef.detectChanges()
	}
	
	initData() {
		this.meessageForm='';
		this.isModify=false;
			
        if (this.consultation) {
            console.log("initData",this.consultation);
            if (this.data.types!=undefined 
            && this.consultation.type!=undefined
            ){
                for(let i=0;i<this.data.types.length;i++)
                    if (this.data.types[i].ID==this.consultation.type.ID) {
                            this.typeInput=this.data.types[i];
                            console.log("data loaded type",this.typeInput,this.data.types[i])
                    }
            } 
			
			this.rdvs=[];
			//this.rdvsActioned=[];
			if (this.consultation.visitesObj!=undefined 
			&& Array.isArray(this.consultation.visitesObj)) {
				this.rdvs= this.consultation.visitesObj;
				for(let i=0;i<this.rdvs.length;i++) {
					let action:any ={
						
						"status": false,
						"pros": false
					}
					this.rdvs[i]["action"]=action;
					
				}
				console.log("CreateConsultationDialogComponent initData",this.rdvs)
			}	
			// console.log("CreateConsultationDialogComponent initData",this.rdvs)           
             // this.typeInput=this.consultation.type;
             if (this.consultation.date_debut!=undefined && this.consultation.date_debut
             && this.consultation.date_fin!=undefined && this.consultation.date_fin
             ) {
                 let begin= new Date(this.consultation.date_debut);
                 let end= new Date(this.consultation.date_fin);    
                 this.dateInput=begin;
                
                 this.valueDebut=formatDate(begin, 'HH:mm', 'fr')
                 this.startTimeInput=this.valueDebut;
                 this.valueFin=formatDate(end, 'HH:mm', 'fr')
                 this.endTimeInput = this.valueFin;
                  console.log("etats loaded consult",this.etats,this.dateInput)
				  
				  let now:Date=new Date();
				  
				  this.disabledForm=(this.dateInput<now);
				  if (this.disabledForm && this.strings.messagForm!=undefined 
					&& this.strings.messagForm.errorDate!=undefined)
					this.meessageForm='<div class="text-danger">' + this.strings.messagForm.errorDate+ '</div>';
				  
				  this.isModify=true;	
              }
               if (this.etats!=undefined 
                &&   this.etats.length>0
                && this.consultation.etat!=undefined
            ){
             for(let i=0;i<this.etats.length;i++)
                            if (this.etats[i].key==this.consultation.etat.key) {
                                this.statusInput=this.etats[i];
                                 console.log("etat select loaded",this.etats)
                             }
            
             }
             if (this.consultation.lieu!=undefined && this.consultation.lieu)
                for(let i=0;i<this.consultationLocation.length;i++)
                    if (this.consultationLocation[i].ID==this.consultation.lieu.ID){
						this.locationInput=this.consultationLocation[i].ID;
						this.initLieuSubject.next(this.locationInput);
						console.log("___locationInput",this.locationInput)
					}
            
            if (this.consultation.intervalle!=undefined) 
             	this.minuteIntervalInput=this.consultation.intervalle;
			
			if(this.consultation.titre){
				this.titre = this.consultation.titre;
			}
            if(this.consultation.commentaire!=undefined && this.consultation.commentaire ){
				this.comment = this.consultation.commentaire;
			}
			
			console.log("initData comment",this.titre,this.comment)
			
            if(this.consultation.professionels){
				this.tiersSearchIsEmpty = false;
                this.consultation.professionels.forEach(el => {
                    this.tiersId.push(el.ID);
                    this.tiersService
                    .getTiersByConsultationType(this.typeInput.ID, {
                        /*tiersId: el.ID,
                        term: term,*/
                    })
                    .subscribe((res: JSONRpcResponse) => {
                        this.tiersSearchList = res.result
                        
                        this.tiersSearchList.forEach(t =>{
                            if(t.tiers.ID == el.ID){
                                this.tiersSelected.push(t.tiers);
                            }
                        })
                        this._groupSearchList();
                        this.changeDetectorRef.detectChanges()
                    })
                });
			}
             
            /* this.title="Modification de consultation";
             this.subtitle="Modification de consultation";*/
             //this.setTitle("Modification de consultation")
             
             this.toLoadDate.next(this.dateInput);     
        	 this.toLoadConsultion.next(true);  
             
            this.data.title="Modification de séance";
          
             this.changeDetectorRef.detectChanges()
        }
    }

	submit(event: any,isNew:boolean=false)  {
        console.log('submit dateInput:',this.dateInput,this.dateInput instanceof moment);
        let ism:boolean=this.dateInput instanceof moment;
		this.errors=[];
		this.errorMessage="";
		if (!this.typeInput)
              this.errors.push("Type ")
        if (!this.dateInput)
              this.errors.push("Date")
        if (!this.statusInput)
              this.errors.push("Etat")            
		if (!this.locationInput)
		      this.errors.push("Lieu");
        if (this.tiersSelected.length<1)
            this.errors.push("Professionnels");
		if (!this.startTimeInput)
              this.errors.push("Heure début")
        if (!this.endTimeInput)
              this.errors.push("Heure fin") 
        if(this.data.dateF==undefined){
            if (
				(this.dateInput && ism && (this.dateInput.days() <= 0 || this.dateInput.days() >= 6))
             )
            this.errors.push("Date invalide")
            
            
            if (this.dateInput && ism)
             	console.log('submit dateInput:',this.dateInput.days());
        
		
        }
        if (this.errors.length>0) {
            
            this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
            this.changeDetectorRef.detectChanges();
        }
        else {
			if(this.periode){
				let nbConsult = this.nbConsult;
				const confDialogRef = this.dialog.open(ConfirmComponent, {
					data : {
						libelle : "Etes-vous sûr de vouloir modifier une(des) séance(s) dûe la répétition ?"
					}
				});
				confDialogRef.afterClosed().subscribe(res => {
					if(res === "true"){ 
						this.createConsultation(isNew);
					}
				})
			} else {
				this.createConsultation(isNew);
			}
		}
	}

	createConsultation(isNew:boolean=false){
		let options = this.getOptions();
		this.loading = true
		
		let ID=0;
		if (this.consultation!=undefined && this.consultation && this.consultation.ID!=undefined && this.consultation.ID>0){
			ID=this.consultation.ID;
		}
		console.log("set constultation",ID,options,this.dateInput)
		
		this.subscriptions.push(this.consultationService.set(ID, this.typeInput.key, options).subscribe((res: JSONRpcResponse) => {
			this.loading = false
			this.dialogRef.close(res)
			if (res.result && this.updateOnCreate)
				this.stateService.updateConsultation(res.result);
			this.changeDetectorRef.detectChanges()
			
			if (isNew && res.result!=undefined) {
										
				let cs:any=res.result;
				
				
						
							let dataCs={
							            action: "create",
							            dataType: "consultation",
							           title: "Création d'une séance",
							            create: true,
							            types:this.data.types,
							            updateOnCreate: false,
										old_consultation: cs,
							        }			
						
						if (this.instruction!=undefined)
							dataCs["instruction"]=	this.instruction;	
						console.log("CreateConsultationDialogComponent createConsultation",dataCs,this.instruction,this.data);						
				        this.dialogService.open(CreateConsultationDialogComponent, {
				            data: dataCs,
				            height: "95vh",
				            width: "80vw",
				            draggable: true,
				            resizable: true,
				            minimizable: true,
				            maximizable: true,
				        }, (res: any) => {
							   console.log("CreateConsultationDialogComponent createConsultation new",res,this.dialogRef)
								this.dialogRef.close(res)
						 });
						
				
				}
            
			
		}))
	}

	changeTypeGroup(type: any = null) {
        var tab = [];
		console.log('select type', type)
        this.typeInput = this.typeInput !== null ?type:null;
		if (type && typeof type === 'object') {
			if (type.lieux != undefined && type.lieux)
				this.loadConsultationLocations(type.lieux)
			if (type.professions!=undefined && type.professions)
				this.professions=type.professions;
			let _opts:any={
				principal: [1,2]
			};
			
			this.subscriptions.push(
				this.consultationService
					.getConsultationTypeGroupe(type.ID,_opts)
					.subscribe((res: JSONRpcResponse) => {
						tab = res.result;
                        this.consultationGroup = tab.filter(group => group.principal === 1 || group.principal === 2);
                        console.log("changeTypeGroup consultationGroup:",this.consultationGroup);
                        
						this.tiersSearchIsEmpty = false
						this.updateSliderObjEdit("type");
						this.toLoadConsultion.next(true);  
					}),
				this.tiersControl.valueChanges
					.pipe(debounceTime(400), distinctUntilChanged())
					.subscribe((term) => {
						this.professions;
						
						this.tiersService
							.getTiersByConsultationType(type.ID, {
								tiersId: this.tiersId,
								term: term,
								location: this.locationInput
							})
							.subscribe((res: JSONRpcResponse) => {
								this.tiersSearchList = res.result
								if(this.data.action == "create" && this.tiersSelected.length == 0){
									this.setUserAsProfessional();
								}
								this._groupSearchList();
								this.changeDetectorRef.detectChanges()
							})
					})
				
			)
			
			let oldv:any=this.tiersControl.value;
	    		let newv:any=(oldv=="*") ? null:"*";	
				this.tiersControl.setValue(newv)	
			if(this.data){
				//this.updateSliderObjEdit("consultType");
			}
		}
		this.changeDetectorRef.detectChanges();
		
	}
	
	_groupSearchList() {
	    let grs:any=[];
	    let lieux:any={
			group:"Ce lieu",
			tiers:[]
		};
		let islieu:boolean=false;
		
		let autres:any={
			group:"Autres",
			tiers:[]
		};
		let isautres:boolean=false;
		
		this.tiersSearchGroupList=[];
		
		for(let i=0;i<this.tiersSearchList.length;i++) {
			if (this.tiersSearchList[i].location) {
			   lieux.tiers.push(this.tiersSearchList[i]);
			   islieu=true;
			}
			else {
				autres.tiers.push(this.tiersSearchList[i]);
				isautres=true;
			}
		}
		if (islieu)
			this.tiersSearchGroupList.push(lieux);
		if (isautres)
			this.tiersSearchGroupList.push(autres);
		console.log("groupSearchList",this.tiersSearchGroupList);
	}

	loadConsultationLocations(lieux: any) {
		console.log('select lieux', lieux)
		if (lieux != undefined && lieux.length > 0) {
			this.subscriptions.push(
				this.tiersService
					.searchByType(lieux)
					.subscribe((res: JSONRpcResponse) => {
						let tt:any={
							
						}
						res.result.sort((a,b) => ( a.NOM > b.NOM) ? 1:-1);
						res.result.forEach((result: any) => {
                           
							let ll={
                                nom: result.NOM ? result.NOM : '',
                                number: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.number) ? result.adresses.PRINCIPALE.number : '',
                                complement: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.complement) ? result.adresses.PRINCIPALE.complement : '',
                                street: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.street) ? result.adresses.PRINCIPALE.street : '',
                                zipCode: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.IDzipcode) ? result.adresses.PRINCIPALE.IDzipcode : '',
                                town: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.town) ? result.adresses.PRINCIPALE.town : '',
                                insee: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.INSEE) ? result.adresses.PRINCIPALE.INSEE : '',
								complete: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.address_complete) ? result.adresses.PRINCIPALE.address_complete : '',
                                ID: result.ID ? result.ID : '',
								type:(result.type_libelle != undefined && result.type_libelle) ? result.type_libelle : ''
                            };
                            /*if(!this.town.includes(ll.town)){
                                this.town.push(ll.town)
                            }
                            */
						   if (tt[ll.town]==undefined) {
							   tt[ll.town]={
								   label:ll.town,
								   consultations:[]
							   };
						   }
                            tt[ll.town].consultations.push(ll);
                            this.consultationLocation.push(ll);
                           
							
							if (this.consultation!=undefined
                             && this.consultation
                             && this.consultation.lieu!=undefined 
                              && this.consultation.lieu
                              && ll.ID==this.consultation.lieu.ID
                              ) {
                                console.log('lieux default',ll,this.consultation.lieu)
                                this.locationInput=ll.ID;
								this.initLieuSubject.next(this.locationInput);
								this.updateSliderObjEdit("location");
                             }
                            this.changeDetectorRef.detectChanges();
						})
					   let tws:any[]= Object.keys(tt).sort((a,b) => ( a > b) ? 1:-1);
					   for (let i = 0; i <tws.length; i++) {
						  //  tt[tws[i]].consultationLocation.sort((a,b) => ( a.nom > b.nom) ? 1:-1);
							this.town.push(tt[tws[i]]);
					   }
					   console.log("___thisTown",this.town);
					})
                    
			)
		}
		
		
		
		
        for (let i = 0; i <this.consultationLocation.length; i++) {
            this.consultationLocation.splice(this.consultationLocation[i],this.consultationLocation.length);
        } 
        for (let i = 0; i <this.town.length; i++) {
            this.town.splice(this.town[i],this.town.length);
        }
        console.log('this.consultationLocation:',this.consultationLocation,'\ntown:',this.town);
	}

	selectTiers(tiers: any) {
		if (this.tiersSelected.indexOf(tiers) === -1) {
			this.tiersSelected.push(tiers)
		}
		this.suiviSearchTerm = ''
		this.tiersSearchList = []
		this.changeDetectorRef.detectChanges()
	}

	supprimer(tiers: any) {
		const index = this.tiersSelected.indexOf(tiers)
		const indexId = this.tiersId.indexOf(tiers.ID)
		if (index >= 0) {
			this.tiersSelected.splice(index, 1)
		}
		if (indexId >= 0) {
			this.tiersId.splice(indexId, 1)
		}
		this.toLoaProfesionnel.next(this.idFiy(this.tiersSelected))
		this.toLoadConsultion.next(true);  
		this.changeDetectorRef.detectChanges()
	}

	ajouter(event: any) {
		const value = (event.value || '').trim()

		if (value) {
			this.tiersSelected.push(value)
		}

		// Clear the input value
		event.chipInput.clear()

		this.tiersControl.setValue(null)
	}

	selected(event: any) {
		this.tiersSelected.push(event.option.value)
		this.tiersId.push(event.option.value.ID)
		this.professionalInput.nativeElement.value = ''
		this.tiersControl.setValue(null)
		
		this.toLoaProfesionnel.next(this.idFiy(this.tiersSelected))
        this.toLoadConsultion.next(true);  
		this.changeDetectorRef.detectChanges()
	}
	
	selectLocation(event: any) { 
		// console.log(event)
	//	this.selectedMember = event.ID ? event.ID : ''
	 console.log('selectLocation',this.professionalInput, this.tiersControl);
	    let oldv:any=this.tiersControl.value;
	    let newv:any=(oldv=="*") ? null:"*";
	    
	    this.tiersControl.setValue(newv, {emitEvent:true});
		this.updateSliderObjEdit("location");
		

	   
	}
	
	idFiy(array: any[]) {
		return array.map(item => {
			if (item.ID != undefined) {
				return item.ID
			} else if (item.id != undefined) {
				return item.id
			} else {
				return item
			}
		})
	}

	 changeDate(event: any) {
		console.log("changeDate",event)
        if (event.value) {
            //if (moment.isDate(event.value)) {
                this.invalidDate = false
                this.dateInput = event.value.toDate();
                console.log("changeDate after",event.value,this.dateInput)
				this.updateSliderObjEdit("date");
                this.toLoadDate.next(event.value.toDate());
                this.toLoadConsultion.next(true); 
                this.changeDetectorRef.detectChanges();
           /*   
            } else {
                this.invalidDate = true
                
            }*/
        } else {
            this.invalidDate = true
        }
    }
    
	timeChange(event: any, position: any) {
		if (position === 'debut') {
			this.startTimeInput = event
		} else {
			this.endTimeInput = event
		}
		this.getPlageCount();
		this.consultChangeDebounce.next("timeslot");
		// console.log(this.startTimeInput, this.endTimeInput, event, position);
	}
	
	toggle(pos: string) {
		
		if (pos == 'right') {
			this.drawerRightIsOpen = !this.drawerRightIsOpen
			
			if (this.drawerRightIsOpen) {
			 
			  console.log("toggle slider");
			  // this.toLoadConsultion=true;
			  this.toLoadConsultionSlider.next(true);
			}
		}
		this.changeDetectorRef.detectChanges();
	}
	
	openPeriodical(){
		let data = {
			dateD:this.dateInput?this.dateInput:null,
			dateF: this.dateF?this.dateF:null,
			period:this.periode?this.periode:null
		}
		this.dialogService.open(PeriodicalCreationComponent, {
			data: data,
			draggable: false,
			maximizable: false,
			minimizable: false,
			resizable: false,
		}, (res: any) => {
			this.nbConsult = res.nbConsult,
			this.periode = res.periode;
			this.dateF = res.dateF;
			this.interval = res.interval
			this.selectedDays = res.selectedDays
			this.monthNumber = res.monthNumber
			this.weekNumber =res.weekNumber
			this.monthMethod =res.monthMethod
			
		})
	}
	
	getPlageCount() {
		 let end:any = this.endTimeInput
           let begin:any = this.startTimeInput
         let count:number=0;
         
         if (end && begin && this.minuteIntervalInput) {
			 
			 let aend:any[]=end.split(":");
			 let abegin:any[]=begin.split(":");
			 if (aend.length>1 && abegin.length>1)  {
				 let minend:number=parseInt(aend[0])*60+parseInt(aend[1]);
				 let minbegin:number=parseInt(abegin[0])*60+parseInt(abegin[1]);
				 count=(minend-minbegin)/this.minuteIntervalInput;
				 count=Math.floor(count);
				// console.log("getPlageCount info",aend,minend,abegin,minbegin)
			 }
		 }
         this.plage=count;
        
         console.log("getPlageCount",end,begin,this.minuteIntervalInput,count);
         
          this.changeDetectorRef.detectChanges();
		
	}
	
	displayAutoLocationList(value: any) {
		console.log("displayAutoLocationList",value)
		let label:any="";
		this.town.forEach((r: any) => {
			let cs:any[]=r.consultations;
			let stop:boolean=false;
			cs.forEach((c: any) => {
				if (!stop 
					&& c.ID==value ){
					stop=true;
					label=c.nom;
				}
			});
		})
		return label;
	}

	getInfosCurrentConsultation(){
		var consult = null;
		if(this.typeInput && this.typeInput.ID){
			var ID = null;
			if (this.consultation!=undefined && this.consultation && this.consultation.ID!=undefined && this.consultation.ID>0){
				ID=this.consultation.ID;
			}
			consult = {
				...this.getOptions(),
				ID:ID,
				type: this.typeInput.ID,
				action: ID? "modif": "create",
				typeObj: "consult"
			}
		}
		return consult;

		
	}

	getOptions(){
		console.log("___INPUTS",this.titre,this.comment)
		let options = {
			lieu: this.locationInput,
			intervalle: this.minuteIntervalDefautlt,
		}

		if (this.groupeInput) {
			options['groupe'] = this.groupeInput
		}
		if (this.statusInput) {
			console.log('etat statusInput',this.statusInput)
			options['etat'] = this.statusInput.key
		}
		
		if(this.periode) {
			options['periode'] = this.periode;

			let date = new Date(this.dateF);
			let newDate = formatDate(date, 'MM/dd/yyyy', 'en');
			let dateF = new Date(newDate + ' '+ this.endTimeInput);
			options['periodeFin'] = dateF;
		}
		
		var date = new Date()
		if (this.dateInput) {
			date =(this.dateInput instanceof Date) ? this.dateInput: new Date(this.dateInput)
		}
		let newDate = formatDate(date, 'MM/dd/yyyy', 'en')
		let startTime = new Date(newDate + ' ' + this.startTimeInput)
		let endTime = new Date(newDate + ' ' + this.endTimeInput)
		options['datedebut'] = startTime
		options['datefin'] = endTime
		
		options["rdvApplicate"]=this.rdvApplicate;
		options["rdvsAction"]=this.rdvs;
		if (this.data.old_consultation!=undefined)
			options["old_consultation"]=this.data.old_consultation;
		console.log("___INPUTS",newDate,this.startTimeInput,this.endTimeInput,this.dateInput,this.titre,this.comment,this.locationInput);
		

		//if (this.hourIntervalInput && this.minuteIntervalInput) {
		if ( this.minuteIntervalInput) {
		//	let hoursToMinutes = this.hourIntervalInput * 60
			let minutes = this.minuteIntervalInput;// + hoursToMinutes
			options['intervalle'] = minutes
		}
		if (this.tiersId.length > 0) {
			options['professionels'] = this.tiersId
		}
		if (this.data!=undefined 
			&& this.data.instruction!=undefined
			&& this.data.instruction)
				options['instruction'] =this.data.instruction.ID;

		if(this.titre!=undefined){
			options['titre'] = this.titre;
		}
		if(this.comment!=undefined){
			options['commentaire'] = this.comment;
		}

		if (this.interval!==undefined) {
			options["interval"] = this.interval
		}

		if (this.selectedDays!==undefined) {
			options["selectedDays"] = this.selectedDays
		}

		if (this.monthNumber!==undefined) {
			options["monthNumber"] = this.monthNumber
		}
		if (this.weekNumber!==undefined) {
			options["weekNumber"] = this.weekNumber
		}
		if (this.monthMethod!==undefined) {
			options["monthMethod"] = this.monthMethod
		}
		
		return options;
	}

	setUserAsProfessional(){
		if(this.user != undefined && this.user){
			const userInListIdx = this.tiersSearchList.findIndex(tiers=>tiers.tiers.ID == this.user.ID)
			if(userInListIdx !== -1){
				this.tiersSelected.push(this.tiersSearchList[userInListIdx].tiers);
				this.tiersId.push(this.user.ID);
			}
		}
	}

	updateSlider(){
		this.consultChangeDebounce.next("plage");
	}

	updateSliderObjEdit(event){
		//let option:any=this.getOptions();
		var currentConsultation = this.getInfosCurrentConsultation();
			
		if(currentConsultation){
			currentConsultation["editType"] = "consult";
			console.log("___consultObjInit",event,currentConsultation)
			this.consultModif.next({obj: currentConsultation, event: event, type: "consult"});
		}
	}
	  
	saisie(event:any) {
		console.log("saisie",event)
	}
	  
	locationChange(event:any){
		this.locationInput = event;
		this.updateSliderObjEdit("location");
	}
	  
}
